import * as React from "react";
import { User } from "../userTypes";
import {
  Select,
  createStyles,
  withStyles,
  FormControl,
  InputLabel,
  MenuItem,
  WithStyles,
  TextField,
  Button,
} from "@material-ui/core";
import UserCommentsPopover from "../UserCommentsPopover";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import handleMutationError from "app/utils/handleMutationError";

interface Props extends WithStyles<typeof styles> {
  user: User;
  refetch: any;
  updateUserRisk?: any;
}

type State = {
  customerRiskAssessment: number;
  commentInput: string;
  loading: boolean;
};

const styles = createStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  inputsParent: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "stretch",
    flex: "0 0 100%",
  },
  formControlSelect: {
    minWidth: 200,
    marginRight: "10px",
  },
  formControlInput: {
    minWidth: 200,
    display: "flex",
    flex: "1 0 auto",
  },
  header: {
    borderBottom: "1px solid rgb(204, 204, 204)",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  },
  comment: {
    fontSize: "16px",
    marginTop: "5px",
    marginBottom: "5px",
  },
  button: {
    marginTop: "10px",
    background: "#4c5a86",
    color: "white",
    width: "10rem",
  },
});

class Details extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      customerRiskAssessment: props.user.customer_risk_assessment,
      commentInput: "",
      loading: false,
    };
  }

  getCRAColour = (risk) => {
    switch (risk) {
      case 2:
        return "orange";
      case 3:
        return "red";
      case 1:
      default:
        return "white";
    }
  };

  handleCRAChange = (event) => {
    this.setState({ customerRiskAssessment: event.target.value });
  };

  handleInputChange = (event) => {
    this.setState({ commentInput: event.target.value });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    this.props
      .updateUserRisk({
        variables: {
          external_reference: this.props.user.external_reference,
          customer_risk_assessment: this.state.customerRiskAssessment,
          comment: this.state.commentInput,
        },
      })
      .then(() => {
        this.setState({ loading: false, commentInput: "" });
        this.props.refetch();
      })
      .catch((error) => {
        handleMutationError(error);
      });
  };

  render() {
    const { classes } = this.props;
    const comments = this.props?.user?.comments;
    const mostRecentComment =
      !!comments && comments.length > 0 ? comments[0] : null;
    return (
      <div className={classes.root}>
        <h3 className={classes.header}>
          <span>Comments</span>
        </h3>

        {!!mostRecentComment ? (
          <UserCommentsPopover comments={comments}>
            <div>{mostRecentComment}</div>
          </UserCommentsPopover>
        ) : null}
        <h3 className={classes.header}>
          <span>Risk</span>
        </h3>
        <form
          onSubmit={this.handleFormSubmit}
          className={classes.root}
          autoComplete="off"
        >
          <div className={classes.inputsParent}>
            <FormControl className={classes.formControlSelect}>
              <InputLabel htmlFor="cra">CRA</InputLabel>
              <Select
                style={{
                  backgroundColor: this.getCRAColour(
                    this.state.customerRiskAssessment
                  ),
                }}
                value={this.state.customerRiskAssessment}
                onChange={this.handleCRAChange}
                inputProps={{
                  name: "customerRiskAssessment",
                  id: "cra",
                }}
              >
                <MenuItem
                  style={{ backgroundColor: this.getCRAColour(1) }}
                  value={1}
                >
                  Low
                </MenuItem>
                <MenuItem
                  style={{ backgroundColor: this.getCRAColour(2) }}
                  value={2}
                >
                  Medium
                </MenuItem>
                <MenuItem
                  style={{ backgroundColor: this.getCRAColour(3) }}
                  value={3}
                >
                  High
                </MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classes.formControlInput} required>
              <TextField
                fullWidth={true}
                label="Comment"
                value={this.state.commentInput}
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
            <Button
              className={classes.button}
              type="submit"
              disabled={this.state.loading}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const updateUserRisk = graphql<Props, any, any>(
  gql`
    mutation updateUserRisk(
      $external_reference: ID!
      $customer_risk_assessment: Int
      $comment: String!
    ) {
      update_user_risk(
        external_reference: $external_reference
        customer_risk_assessment: $customer_risk_assessment
        comment: $comment
      ) {
        external_reference
      }
    }
  `,
  { name: "updateUserRisk" }
);

export default compose(withStyles(styles), updateUserRisk)(Details);
